<template>
  <OnePageContainer
    :show_bottom_left="false"
    class="ffl-layout"
  >
    <template #top>
      <v-tabs
        v-model="activeTab"
        background-color="transparent"
        class="fl__tabs mb-2"
        height="35"
        hide-slider
      >
        <v-tab
          :to="{ name: 'FastLineLiteAgents' }"
          :exact="false"
        >
          <v-icon size="18" class="mr-1">$vuetify.icons.iconaiagent</v-icon>
          {{$t('modules.fast_line_lite.agents.title')}}
        </v-tab>
        <v-tab
          :to="{ name: 'FastLineLiteDatasets' }"
          :exact="false"
        >
          <v-icon size="18" class="mr-1">mdi-folder-outline</v-icon>
          {{$t('modules.fast_line_lite.datasets.title')}}
        </v-tab>
      </v-tabs>
    </template>

    <template #bottom-left
      v-if="false"
    />

    <template #bottom-right>
      <router-view></router-view>
    </template>


  </OnePageContainer>
</template>
<script>

import OnePageContainer from "@/components/Modules/Extra/OnePageBlocks/OnePageContainer.vue";

export default {
  components: {OnePageContainer},
  data() {
    return {
      activeTab: this.$route.name,
    };
  },
  watch: {
    $route(to) {
      this.activeTab = to.name;
    },
  },
};
</script>

<style lang="scss">
.fl__tabs {

  &:after {
    content: '';
    display: block;
    height: 1px;
    background: var(--v-blueHaze-base);
    margin-right: 52px;
    margin-left: 52px;
    margin-top: -1px;
  }

  .v-tab {
    border-bottom: 1px solid var(--v-blueHaze-base);
    font-size: 0.875rem;
    padding: 0 10px;
    text-transform: none;
  }
}


.ffl-layout {
  overflow: hidden;

  .one-page__table {
    height: 100% !important;
  }
  .one-page__bottom-nav {
    overflow: hidden;
  }

}

</style>